// @noflow

export { UpdateDogAboutInfo as UpdateDogAboutInfoV2 } from './UpdateDogAboutInfo'
